// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__35Jph","left":"InfoRow_left__3D-dP"};